module.exports = __webpack_public_path__ + "img/home_image_2_fr.351e7fcf.png";